<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaldedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field v-model="insurance.name" label="Sigorta Adı" :counter="max" required></v-text-field>
      </v-flex>
      <v-flex xs12 md12>
        <v-switch v-model="insurance.state" :label="`Aktif Mi:`"></v-switch>
      </v-flex>
      <v-btn color="success" @click="saveInsurance">Kaydet</v-btn>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  data: () => ({
    select: [],
    selectCategory: {},
    alert: false,
    allowSpaces: false,
    match: "Foobar",
    max: 0,
    model: "Foobar",
    insurance: {
      state: true
    }
  }),

  watch: {},

  methods: {
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    async saveInsurance() {
      let insurance = Object.assign({}, this.insurance);
      if (this.insurance.id) this.$store.dispatch("insurances/putInsurance", insurance);
      else this.$store.dispatch("insurances/postInsurance", insurance);
      this.alert = true;
    },
  },
  computed: {},
  async mounted() {
    if (this.$route.params.id) {
      await this.$store.dispatch("insurances/getInsurance", this.$route.params.id);
      this.insurance = this.$store.state.insurances.insurance;
    }
  },
  async created() {
  }
};
</script>